import React, { useState, useMemo } from 'react';
import CalcShell from '../CalcShell';

// Mulch — depth × area, output in cubic yards / bags
export default function MulchCalc() {
  const [length, setLength] = useState(20);
  const [width, setWidth] = useState(10);
  const [depth, setDepth] = useState(3);
  const [unit, setUnit] = useState('ft'); // ft or m
  const [depthUnit, setDepthUnit] = useState('in');
  const [bagSize, setBagSize] = useState(2); // cu ft
  const [price, setPrice] = useState(4.50);

  const result = useMemo(() => {
    const toFt = { ft:1, m:3.28084 };
    const depthFt = depthUnit === 'in' ? Number(depth) / 12 : Number(depth) * toFt[unit] || 0;
    const areaFt2 = Number(length) * Number(width) * (toFt[unit] ** 2);
    const cuFt = areaFt2 * depthFt;
    const cuYd = cuFt / 27;
    const bags = bagSize ? Math.ceil(cuFt / Number(bagSize)) : 0;
    const cost = bags * Number(price);
    return { areaFt2, cuFt, cuYd, bags, cost };
  }, [length, width, depth, unit, depthUnit, bagSize, price]);

  return (
    <CalcShell look="cnet" title="Mulch Calculator" subtitle="Compute how much mulch you need (cubic yards, cubic feet or bags) and the estimated cost.">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="grid grid-cols-2 gap-3">
            <div className="field"><label>Length</label><input type="number" value={length} onChange={e => setLength(e.target.value)}/></div>
            <div className="field"><label>Width</label><input type="number" value={width} onChange={e => setWidth(e.target.value)}/></div>
          </div>
          <div className="field"><label>Area Unit</label>
            <select value={unit} onChange={e => setUnit(e.target.value)}><option value="ft">ft — foot</option><option value="m">m — meter</option></select>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="field"><label>Depth</label><input type="number" value={depth} onChange={e => setDepth(e.target.value)}/></div>
            <div className="field"><label>Depth Unit</label>
              <select value={depthUnit} onChange={e => setDepthUnit(e.target.value)}><option value="in">in — inch</option><option value="ft">ft — foot</option><option value="m">m — meter</option></select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="field"><label>Bag Size (cu ft)</label><input type="number" value={bagSize} onChange={e => setBagSize(e.target.value)}/></div>
            <div className="field"><label>Price / Bag</label><input type="number" step="0.01" value={price} onChange={e => setPrice(e.target.value)}/></div>
          </div>
        </div>
        <div>
          <div className="p-5 rounded-xl bg-amber-50 border border-amber-200 text-center">
            <div className="text-sm text-slate-600">Mulch Needed</div>
            <div className="text-4xl font-bold text-amber-800" data-testid="mulch-result">{result.cuYd.toFixed(2)} yd³</div>
            <div className="text-lg text-slate-700 mt-1">{result.cuFt.toFixed(2)} ft³ · {result.bags} bags</div>
            <div className="mt-3 text-sm text-slate-600">Estimated Cost</div>
            <div className="text-2xl font-bold">${result.cost.toFixed(2)}</div>
          </div>
        </div>
      </div>
    </CalcShell>
  );
}
